import { render, staticRenderFns } from "./PurchaseSimulation.vue?vue&type=template&id=1215ad5a"
import script from "./PurchaseSimulation.vue?vue&type=script&lang=js"
export * from "./PurchaseSimulation.vue?vue&type=script&lang=js"
import style0 from "./PurchaseSimulation.vue?vue&type=style&index=0&id=1215ad5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports